const File = [
  {
    type: 'item',
    text: 'Create Shortcut',
    disable: true,
  },
  {
    type: 'item',
    text: 'Delete',
    disable: true,
  },
  {
    type: 'item',
    text: 'Rename',
    disable: true,
  },
  {
    type: 'item',
    text: 'Properties',
    disable: true,
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Close',
  },
];

const Edit = [
  {
    type: 'item',
    text: 'Undo',
    hotkey: 'Ctrl+Z',
    disable: true,
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Cut',
    hotkey: 'Ctrl+X',
    disable: true,
  },
  {
    type: 'item',
    text: 'Copy',
    hotkey: 'Ctrl+C',
    disable: true,
  },
  {
    type: 'item',
    text: 'Paste',
    hotkey: 'Ctrl+V',
    disable: true,
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Select All',
    hotkey: 'Ctrl+A',
    disable: true,
  },
];

const View = [
  {
    type: 'item',
    text: 'Toolbars',
    disable: true,
  },
  {
    type: 'item',
    text: 'Status Bar',
    disable: true,
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Refresh',
  },
];

const Favorites = [
  {
    type: 'item',
    text: 'Add to Favorites...',
    disable: true,
  },
  {
    type: 'item',
    text: 'Organize Favorites...',
    disable: true,
  },
];

const Tools = [
  {
    type: 'item',
    text: 'Map Network Drive...',
    disable: true,
  },
  {
    type: 'item',
    text: 'Disconnect Network Drive...',
    disable: true,
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Folder Options...',
    disable: true,
  },
];

const Help = [
  {
    type: 'item',
    text: 'Help and Support Center',
    disable: true,
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'About lottel.fun',
    disable: true,
  },
];

const dropDownData = {
  File,
  Edit,
  View,
  Favorites,
  Tools,
  Help,
};

export default dropDownData;
